import { FileText, Target, TrendingUp, Zap } from 'lucide-react'

const stats = [
    {
        label: 'Words Analyzed',
        value: '12,487',
        change: '+23%',
        changeType: 'positive',
        icon: FileText,
        color: 'primary',
    },
    {
        label: 'Clichés Detected',
        value: '89',
        change: '-12%',
        changeType: 'positive',
        icon: Target,
        color: 'accent',
    },
    {
        label: 'Writing Score',
        value: '87',
        change: '+5',
        changeType: 'positive',
        icon: TrendingUp,
        color: 'green',
    },
    {
        label: 'AI Requests',
        value: '156',
        change: 'Unlimited',
        changeType: 'neutral',
        icon: Zap,
        color: 'yellow',
    },
]

const colorMap = {
    primary: {
        bg: 'bg-primary-500/20',
        text: 'text-primary-400',
        icon: 'text-primary-400',
    },
    accent: {
        bg: 'bg-accent-500/20',
        text: 'text-accent-400',
        icon: 'text-accent-400',
    },
    green: {
        bg: 'bg-green-500/20',
        text: 'text-green-400',
        icon: 'text-green-400',
    },
    yellow: {
        bg: 'bg-yellow-500/20',
        text: 'text-yellow-400',
        icon: 'text-yellow-400',
    },
}

export default function StatsOverview({ data }) {
    const displayStats = data || stats

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {displayStats.map((stat, index) => {
                const colors = colorMap[stat.color] || colorMap.primary
                const Icon = stat.icon

                return (
                    <div key={index} className="stats-card group hover:border-white/20 transition-colors">
                        <div className="flex items-start justify-between mb-4">
                            <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center group-hover:scale-110 transition-transform`}>
                                <Icon className={`w-6 h-6 ${colors.icon}`} />
                            </div>
                            <span className={`text-sm font-medium ${stat.changeType === 'positive' ? 'text-green-400' :
                                    stat.changeType === 'negative' ? 'text-red-400' :
                                        'text-white/50'
                                }`}>
                                {stat.change}
                            </span>
                        </div>
                        <div className="stats-value">{stat.value}</div>
                        <div className="stats-label">{stat.label}</div>
                    </div>
                )
            })}
        </div>
    )
}
